import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: { name: 'catalog' }
  },

  // ////////////////////////////////////////////////////////////////////////
  // COMMON / PERONAL PART
  // ////////////////////////////////////////////////////////////////////////
  {
    meta: {
      title: 'Главная страница'
    },
    path: '/catalog',
    name: 'catalog',
    component: () => import(
      /* webpackChunkName: "Catalog" */
      '../modules/Catalog/Catalog.vue'
    )
  },
  {
    meta: {
      title: 'Заказы'
    },
    path: '/orders',
    name: 'orders',
    component: () => import(
      /* webpackChunkName: "Orders" */
      '../modules/Orders/Orders.vue'
    )
  },
  {
    meta: {
      title: 'Новый заказ'
    },
    path: '/order/new',
    name: 'order-new',
    component: () => import(
      /* webpackChunkName: "OrderNew" */
      '../modules/OrderNew/OrderNew.vue'
    )
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'is-active',
  routes
});

import store from '../store'

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    window.document.title = `${to.meta.title} | Русбиомикс: личный кабинет`
  }

  store.commit('hideSubmenu');

  next();
})

export default router
